import { useState } from "react"
import { MessageType, useMessageReport } from "../MessageReporter"
import { Col, Form, Row } from "react-bootstrap"
import { ReactSelect } from "../ReactSelect"

const deviceListUrl = process.env.REACT_APP_DEVICE_LIST_URL
const deviceListUrlV2 = process.env.REACT_APP_DEVICE_LIST_URL_V2

export const FirmwareUriInput = ({ setFirmware }) => {
    const { addMessage } = useMessageReport()

    const [url, setUrl] = useState({
        cert: "...",
        env: "...",
        device: "...",
        uri: "...",
    })

    const certOptions = ["v1", "v2"]
    const envOptions = ["prd", "dev"]
    const [deviceOptions, setDeviceOptions] = useState([])
    const [uriOptions, setUriOptions] = useState([])

    const onCertChange = (value) => {
        url.cert = value
        url.env = "..."
        url.device = "..."
        url.uri = "..."
        setUrl({ ...url })
        setFirmware({ device: "", uri: "" })
    }
    const onEnvChange = (value) => {
        url.env = value
        url.device = "..."
        url.uri = "..."
        setUrl({ ...url })
        getFirmwareOptions(addMessage, url).then((devs) => setDeviceOptions(devs || []))
        setFirmware({ device: "", uri: "" })
    }
    const onDeviceChange = (value) => {
        url.device = value
        url.uri = "..."
        setUrl({ ...url })
        getFirmwareOptions(addMessage, url).then((bins) =>
            setUriOptions(
                bins.map((u) => ({
                    label: u.name,
                    value: u.name,
                }))
            )
        )
        setFirmware({ device: "", uri: "" })
    }
    const onUriChange = (value) => {
        url.uri = value
        setUrl({ ...url })
        setFirmware({
            device: url.device.toUpperCase(),
            uri: urlToString(url),
        })
    }

    return (
        <Row className="mb-3">
            <Col xs={12} md={2}>
                <Form.Group>
                    <Form.Label>Certificate</Form.Label>
                    <Form.Select onChange={(e) => onCertChange(e.target.value)} value={url.cert}>
                        <option disabled>...</option>
                        {certOptions.map((type) => (
                            <option key={type}>{type}</option>
                        ))}
                    </Form.Select>
                </Form.Group>
            </Col>
            <Col xs={12} md={2}>
                <Form.Group>
                    <Form.Label>Environment</Form.Label>
                    <Form.Select
                        disabled={url.cert === "..."}
                        onChange={(e) => onEnvChange(e.target.value)}
                        value={url.env}
                    >
                        <option disabled>...</option>
                        {envOptions.map((type) => (
                            <option key={type}>{type}</option>
                        ))}
                    </Form.Select>
                </Form.Group>
            </Col>
            <Col xs={12} md={2}>
                <Form.Group>
                    <Form.Label>Device type</Form.Label>
                    <Form.Select
                        disabled={url.env === "..."}
                        onChange={(e) => onDeviceChange(e.target.value)}
                        value={url.device}
                    >
                        <option disabled>...</option>
                        {deviceOptions.map((type) => (
                            <option key={type.name}>{type.name}</option>
                        ))}
                    </Form.Select>
                </Form.Group>
            </Col>
            <Col xs={12} md={6}>
                <Form.Group>
                    <Form.Label>Uri</Form.Label>
                    <ReactSelect
                        isDisabled={url.device === "..."}
                        value={url.uri}
                        options={uriOptions}
                        onChange={onUriChange}
                    />
                </Form.Group>
            </Col>
            <Form.Text muted className="text-end">
                {urlToString(url)}
            </Form.Text>
        </Row>
    )
}

const urlToString = (url) => {
    let str = ""

    if (url.cert === "v1") {
        str += deviceListUrl
    }
    if (url.cert === "v2") {
        str += deviceListUrlV2
    }

    if (url.env === "dev") {
        str += "dev/"
    }

    if (url.device !== "...") {
        str += url.device + "/"
    }

    if (url.uri !== "...") {
        str += url.uri.value
    }

    return str
}

const getFirmwareOptions = (addMessage, url) =>
    fetch(urlToString(url))
        .then((response) => response.json())
        .then((data) => data.filter((e) => e.name !== "dev" && e.name !== "nightly"))
        .catch((e) => {
            addMessage(
                "Failed to get device types",
                <>
                    Something went wrong while getting the firmware, see the console for more
                    details.
                    <br />
                    <br />
                    You can probably solve this problem by going to{" "}
                    <a target="_blank" rel="noreferrer" href={urlToString(url)}>
                        {urlToString(url)}
                    </a>{" "}
                    and accepting the certificate.
                </>,
                MessageType.error,
                e
            )
        })
